import { Action } from "./action";

export function runActions(actions, data, componentIdMap, sender) {
    Action.doActions(actions, data, componentIdMap, sender);
}